export const POSTHOG_PROJECT_TOKEN = process.env.REACT_APP_POSTHOG_PROJECT_TOKEN

export const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://eu.i.posthog.com'

const redactSharedValuationUrl = (value) => {
  if (typeof value !== 'string') return value
  return value.replace(/\/v\/[A-Za-z0-9_-]{32,128}/g, '/v/[shared-valuation]')
}

export const POSTHOG_OPTIONS = {
  api_host: POSTHOG_HOST,
  defaults: '2026-01-30',
  before_send: (event) => {
    if (!event?.properties) return event

    const properties = { ...event.properties }
    const urlProperties = [
      '$current_url',
      '$pathname',
      '$referrer',
      '$initial_current_url',
      '$initial_referrer',
    ]

    urlProperties.forEach((property) => {
      properties[property] = redactSharedValuationUrl(properties[property])
    })

    return { ...event, properties }
  },
}
